import React from "react";
import { Box, BoxProps, Icon } from "@chakra-ui/react";
import { FaHeart } from "react-icons/fa";

export const HEART_RED = "#ef4444";

interface MessageHeartBadgeProps {
  /** Who left it — "You" or the brand's name. */
  lovedBy: string;
  /** Set when the viewer left this heart: tapping it takes it back. */
  onRemove?: () => void;
}

const badgeStyle: BoxProps = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  mt: "-8px",
  mx: "10px",
  position: "relative",
  zIndex: 1,
  w: "22px",
  h: "22px",
  p: 0,
  border: "none",
  borderRadius: "full",
  bg: "white",
  boxShadow: "0 0 0 2px white, 0 1px 3px rgba(0,0,0,0.18)",
};

/**
 * The red heart under a bubble someone loved, pulled up over the bubble's bottom edge. Mirrors the
 * brand inbox so a heart looks the same on both sides of the thread.
 */
const MessageHeartBadge: React.FC<MessageHeartBadgeProps> = ({ lovedBy, onRemove }) => {
  const heart = <Icon as={FaHeart} color={HEART_RED} boxSize="11px" />;
  return onRemove ? (
    <Box as="button" type="button" aria-label="Remove your heart" cursor="pointer" onClick={onRemove} {...badgeStyle}>
      {heart}
    </Box>
  ) : (
    <Box as="span" role="img" aria-label={`${lovedBy} loved this`} title={`${lovedBy} loved this`} {...badgeStyle}>
      {heart}
    </Box>
  );
};

export default MessageHeartBadge;
